import React from 'react';
import { 
  Paper, 
  Typography, 
  List, 
  ListItem, 
  ListItemText,
  Grid,
  Box 
} from '@mui/material';

const OrderedLists = ({ results }) => {
  if (!results || !results.questions) return null;

  const timeSpent = results.questions
    .find(q => q.questionKey === 'time_spent')?.rankings
    .sort((a, b) => b.score - a.score) || [];

  const timeDesired = results.questions
    .find(q => q.questionKey === 'time_desired')?.rankings
    .sort((a, b) => b.score - a.score) || [];

  const competencies = results.questions
    .find(q => q.questionKey === 'competency')?.rankings
    .sort((a, b) => b.score - a.score) || [];

  const renderList = (items, title) => (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <List dense>
        {items.map((item, index) => (
          <ListItem key={index}>
            <ListItemText
              primary={`${index + 1}. ${item.item}`}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        Classements Détaillés
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          {renderList(timeSpent, 'Temps Actuel')}
        </Grid>
        <Grid item xs={12} md={4}>
          {renderList(timeDesired, 'Temps Souhaité')}
        </Grid>
        <Grid item xs={12} md={4}>
          {renderList(competencies, 'Compétences')}
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderedLists; 